import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';

@Component({
  selector: 'app-ikusei-kiroku-sub-dialog',
  templateUrl: './ikusei-kiroku-sub-dialog.component.html',
  styleUrls: ['./ikusei-kiroku-sub-dialog.component.scss']
})
export class IkuseiKirokuSubDialogComponent implements OnInit {
  public meisai: any = {};
  public shubetsu = '';
  title = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public commonService: CommonService,
              public matDialogRef: MatDialogRef<IkuseiKirokuSubDialogComponent>,) { }

  /**
   *
   */
  ngOnInit(): void {
    this.meisai = this.data.meisai;
    this.shubetsu = this.data.shubetsu;
    switch (this.shubetsu) {
      case 'eachFeedAndWeeksCount':
        this.title = '飼料追加・修正';
        break;
      case 'vaccineList':
        this.title = 'ワクチンプログラム追加・修正';
        break;
    }
  }
}
